'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTestLibrarySupported = undefined;
exports.default = createTest;

var _tape = require('./tape');

var _tape2 = _interopRequireDefault(_tape);

var _ava = require('./ava');

var _ava2 = _interopRequireDefault(_ava);

var _mocha = require('./mocha');

var _mocha2 = _interopRequireDefault(_mocha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var libToTestCreation = {
  'tape': _tape2.default,
  'ava': _ava2.default,
  'mocha': _mocha2.default
};

var isTestLibrarySupported = exports.isTestLibrarySupported = function isTestLibrarySupported(lib) {
  return Object.keys(libToTestCreation).indexOf(lib) !== -1;
};

function createTest(_ref) {
  var testLib = _ref.testLib;
  var state = _ref.state;
  var actions = _ref.actions;
  var imports = _ref.imports;
  var reducer = _ref.reducer;
  var equalityFunction = _ref.equalityFunction;

  return libToTestCreation[testLib](arguments[0]);
}


/*****************
 ** WEBPACK FOOTER
 ** ./dist/create-test/index.js
 ** module id = 178
 ** module chunks = 0
 **/